/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useChartData } from "../data/useChartData";
import { useHighchartTransformer } from "../transformers/useHighchartTransformer";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import HighchartsChart from "../../../../charts/components/HighchartsChart";
import { useExportQuery } from "../export/useExportQuery";
import { useSubscription } from "../subscription/useSubscription";
import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";
import { useSubscriptionSource } from "../../../shared";

export const ComponentChart: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResult = useHookSubscribe(null, context.olapResult$);
  const parameters = useHookSubscribe(null, context.parameters);
  const loading = useHookSubscribe(null, context.loading$);
  const source = useHookSubscribe(null, context.sources$);
  const calendarMark = useHookSubscribe(null, context.calendarMark$);

  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  useExportQuery(title, subtitle, source, calendarMark);
  useSubscription(calendarMark);
  useSubscriptionSource(source);

  const chartData = useChartData(olapResult);
  const highchartData = useHighchartTransformer(chartData, parameters);

  if (window["exportMode"]) {
    window["exportReady"] = !loading;
  }

  if (loading) {
    return <ComponentPreloader />;
  }
  return (
    <>
      <ComponentSourcetitle>Source: {source || "USDA Prices"}</ComponentSourcetitle>
      <HighchartsChart data={highchartData} loader={<ComponentPreloader />} />
    </>
  );
};
